import React from "react";

const Localities = () => {
  const localitiesData = [
    {
      title: "Tarn Taran Locality",
      places: "20",
    },
    {
      title: "Chohla Sahib Locality",
      places: "25",
    },
    {
      title: "Sangarur Locality",
      places: "154",
    },
  ];
  return (
    <div>
      <div className="row container m-auto pb-5 my-5">
        <h2 className="mb-4">
          Popular localities in and around{" "}
          <span className="fw-bold">Tarn Taran</span>
        </h2>
        {localitiesData.map((data) => {
          return (
            <div className="col-md-4" style={{ cursor: "pointer" }}>
              <div class="card-body shadow px-3 py-3 my-3">
                <h5 class="card-title">{data.title}</h5>
                <p class="card-text">{data.places} places</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Localities;
